export default function PostTypesSection() {
  const postTypes = [
    {
      title: 'Just Listed',
      description: 'Showcase new properties with stunning visuals and key details',
      icon: 'ri-home-4-line',
      preview: 'https://public.readdy.ai/ai/img_res/61576ac3e077cdf6ac65d12d568c75f1.jpg'
    },
    {
      title: 'Just Sold',
      description: 'Celebrate successful closings and build social proof',
      icon: 'ri-key-line',
      preview: 'https://readdy.ai/api/search-image?query=beautiful%20residential%20home%20with%20sold%20sign%20houston%20neighborhood%20sunny%20day%20professional%20real%20estate%20photography&width=300&height=300&seq=post-type-just-sold-003&orientation=squarish'
    },
    {
      title: 'Buyer Tips',
      description: 'Share valuable advice for first-time and experienced buyers',
      icon: 'ri-lightbulb-line',
      preview: 'https://readdy.ai/api/search-image?query=minimal%20graphic%20design%20template%20with%20buyer%20tip%20text%20on%20clean%20beige%20background%20with%20orange%20accent%20modern%20social%20media%20post&width=300&height=300&seq=post-type-buyer-tip-003&orientation=squarish'
    },
    {
      title: 'Seller Tips',
      description: 'Help homeowners prepare their properties for maximum value',
      icon: 'ri-price-tag-3-line',
      preview: 'https://readdy.ai/api/search-image?query=minimal%20list%20design%20template%20with%20numbered%20seller%20tips%20on%20clean%20white%20background%20with%20orange%20accents%20modern%20real%20estate%20post&width=300&height=300&seq=post-type-seller-tip-003&orientation=squarish'
    },
    {
      title: 'Market Updates',
      description: 'Position yourself as the local market expert with data insights',
      icon: 'ri-line-chart-line',
      preview: 'https://readdy.ai/api/search-image?query=clean%20data%20visualization%20chart%20showing%20real%20estate%20market%20statistics%20with%20orange%20and%20beige%20colors%20minimal%20modern%20infographic&width=300&height=300&seq=post-type-market-003&orientation=squarish'
    },
    {
      title: 'Client Testimonials',
      description: 'Let happy clients tell your story and build trust',
      icon: 'ri-star-line',
      preview: 'https://readdy.ai/api/search-image?query=elegant%20testimonial%20quote%20card%20design%20with%20five%20stars%20on%20soft%20beige%20background%20minimal%20modern%20typography&width=300&height=300&seq=post-type-testimonial-003&orientation=squarish'
    },
    {
      title: 'Open House',
      description: 'Drive attendance with eye-catching event announcements',
      icon: 'ri-door-open-line',
      preview: 'https://readdy.ai/api/search-image?query=inviting%20home%20entrance%20with%20open%20front%20door%20welcoming%20interior%20houston%20residential%20bright%20natural%20lighting&width=300&height=300&seq=post-type-open-house-003&orientation=squarish'
    },
    {
      title: 'Meet the Agent',
      description: 'Build personal connection and showcase your expertise',
      icon: 'ri-user-smile-line',
      preview: 'https://readdy.ai/api/search-image?query=professional%20real%20estate%20agent%20portrait%20in%20business%20attire%20standing%20confidently%20modern%20office%20background%20warm%20lighting&width=300&height=300&seq=post-type-meet-agent-003&orientation=squarish'
    },
    {
      title: 'Neighborhood Spotlight',
      description: 'Highlight local communities and attract area-specific buyers',
      icon: 'ri-map-pin-line',
      preview: 'https://readdy.ai/api/search-image?query=beautiful%20houston%20neighborhood%20street%20view%20with%20tree%20lined%20sidewalks%20and%20charming%20homes%20sunny%20residential%20community&width=300&height=300&seq=post-type-neighborhood-003&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 px-6 bg-[#F8F4EF]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <div className="text-[#E8603C] uppercase tracking-wider text-sm font-semibold mb-3">
            Templates
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            9 Post Types Included
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Every template category you need to create a balanced, engaging feed that attracts buyers and sellers.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {postTypes.map((post, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden border border-black/6 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10),0_30px_60px_rgba(0,0,0,0.14)] transition-all duration-200 hover:-translate-y-1"
              style={{
                boxShadow: '0 6px 12px rgba(0,0,0,0.06), 0 18px 40px rgba(0,0,0,0.10)',
                transform: index >= 3 && index < 6 ? 'translateY(15px)' : 'translateY(0)'
              }}
            >
              {/* Card Content */}
              <div className="p-6">
                <div className="w-12 h-12 rounded-lg bg-[#E8603C] flex items-center justify-center mb-4">
                  <i className={`${post.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {post.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  {post.description}
                </p>

                {/* Mini Instagram Preview */}
                <div className="bg-gray-50 p-3 rounded-lg">
                  <div className="bg-white rounded-lg overflow-hidden shadow-sm">
                    {/* Mini Header */}
                    <div className="flex items-center gap-2 p-2 border-b border-gray-100">
                      <div className="w-5 h-5 rounded-full bg-gradient-to-br from-[#E8603C] to-orange-400"></div>
                      <div className="flex-1">
                        <div className="text-[10px] font-semibold text-gray-900">yourname.realty</div>
                        <div className="text-[8px] text-gray-500">📍 Houston, Texas</div>
                      </div>
                      <i className="ri-more-fill text-[10px] text-gray-400"></i>
                    </div>
                    {/* Mini Image */}
                    <div className="aspect-square bg-gray-100">
                      <img
                        src={post.preview}
                        alt={post.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}